import { AssemblyHeaderRow, BoMItemType } from 'model/Project/BoMItemRow'
import { RootAppState } from 'store/configureStore'
import { BoMItemSatisfyActiveFilters } from 'utils/BoMItemSatisfyActiveFilters'
import { BomItemPointer } from './previousAndNextBomItemIdsSelector'

export const getPreviousAndNextItemByAssembly = (
  state: RootAppState,
  bomItemId: string
) => {
  let previous: BomItemPointer = null
  let next: BomItemPointer = null

  const assemblyIndex = state.project.assemblyHeadersIds.indexOf(bomItemId)

  if (assemblyIndex > -1) {
    if (assemblyIndex === 0) {
      previous = {
        bomItemId: state.project.activeProject?.id,
        bomItemType: BoMItemType.project,
      }
    } else {
      let previousAssemblyId = null

      for (let i = assemblyIndex - 1; i >= 0; i--) {
        if (
          BoMItemSatisfyActiveFilters(
            state.project.filters,
            state.project.flatView[state.project.assemblyHeadersIds[i]]
          )
        ) {
          previousAssemblyId = state.project.assemblyHeadersIds[i]
          break
        }
      }

      if (!previousAssemblyId) {
        // previous will be the project
        previous = {
          bomItemId: state.project.activeProject?.id,
          bomItemType: BoMItemType.project,
        }
      } else {
        // previous will be the last partType (that satisfy the filters); of the previous assembly that satisfy the filters
        const partTypeIdsOfPreviousAssembly = (
          state.project.flatView[previousAssemblyId] as AssemblyHeaderRow
        ).filteredPartTypeIds

        if (partTypeIdsOfPreviousAssembly.length > 0) {
          previous = {
            bomItemId:
              partTypeIdsOfPreviousAssembly[
                partTypeIdsOfPreviousAssembly.length - 1
              ],
            bomItemType: BoMItemType.row,
          }
        }
      }
    }

    const assemblyHeader = state.project.flatView[
      bomItemId
    ] as AssemblyHeaderRow

    if (assemblyHeader) {
      if (Boolean(assemblyHeader.filteredPartTypeIds[0])) {
        next = {
          bomItemId: assemblyHeader.filteredPartTypeIds[0],
          bomItemType: BoMItemType.row,
        }
      }
    }

    return {
      previousBomItem: previous,
      nextBomItem: next,
    }
  }

  const bomItem = state.project.flatView && state.project.flatView[bomItemId]

  if (bomItem?.type === 'Row') {
    const rowAssembly = state.project.flatView[
      bomItem.parentId
    ] as AssemblyHeaderRow

    if (rowAssembly) {
      const rowIndex = rowAssembly.filteredPartTypeIds.indexOf(bomItemId)

      if (rowIndex > -1) {
        if (rowIndex === 0) {
          previous = {
            bomItemId: rowAssembly.assembly.id,
            bomItemType: BoMItemType.assemblyHeader,
          }
        } else {
          previous = {
            bomItemId: rowAssembly.filteredPartTypeIds[rowIndex - 1],
            bomItemType: BoMItemType.row,
          }
        }

        if (rowIndex === rowAssembly.filteredPartTypeIds.length - 1) {
          // last row of an assembly, next will be the next assembly header
          const parentAssemblyIndex = state.project.assemblyHeadersIds.indexOf(
            rowAssembly.assembly.id
          )

          let nextAssembly = null

          for (
            let i = parentAssemblyIndex + 1;
            i < state.project.assemblyHeadersIds.length;
            i++
          ) {
            if (
              BoMItemSatisfyActiveFilters(
                state.project.filters,
                state.project.flatView[state.project.assemblyHeadersIds[i]]
              )
            ) {
              nextAssembly = state.project.assemblyHeadersIds[i]
              break
            }
          }

          if (nextAssembly) {
            next = {
              bomItemId: nextAssembly,
              bomItemType: BoMItemType.assemblyHeader,
            }
          }
        } else {
          next = {
            bomItemId: rowAssembly.filteredPartTypeIds[rowIndex + 1],
            bomItemType: BoMItemType.row,
          }
        }
      }
    }
  }

  return {
    previousBomItem: previous,
    nextBomItem: next,
  }
}
